module.exports = "/static/assets/276b880da7173e717f5265fa518a3729.gif";